module.exports = __webpack_public_path__ + "img/clearview.ad6ab4c7.jpeg";